export const BAC_ADMISSION_DATA = {
  briefText: {
    ar: `"هل أنتم على وشك تسجيل طفتلكم في مدرسة؟ أنتم في المكان الصحيح!
 كما قال بول فاليري، الكاتب والشاعر والفيلسوف الفرنسي (1871-1945):
 ""التعليم هو مفتاح الحضارة.""
 هنا تبدأ الرحلة نحو مستقبل مشرق وغني!"`,
    fr: `"Vous vous apprêtez à inscrire votre enfant à l'école ? Vous êtes au bon endroit ! 
 Comme le disait Paul Valéry, écrivain, poète et philosophe français (1871-1945) : « L'éducation est la clé de la civilisation. » C'est ici que commence le voyage vers un avenir éclairé et enrichissant !"
`,
    en: `Are you about to enroll your child in school? You are in the right place!
 As Paul Valéry, French writer, poet, and philosopher (1871-1945), said:
 ""Education is the key to civilization.""
 This is where the journey towards a bright and enriching future begins!
`,
  },
  details: [
    // {
    //   title: {
    //     ar: 'المرحلة الابتدائية',
    //     fr: 'Élémentaire',
    //     en: 'Junior Departement',
    //   },
    //   order: 2,
    //   image: 'elementaire.jpg',
    //   attachments: [], // TODO : Attach maternel 2025.png
    //   links: [], // TODO: fill it
    //   url: 'https://www.facebook.com/Ecole.Girard.Alexandria',
    //   type: 'admisison',
    //   isArchived: false,
    // },
    // {
    //   title: {
    //     ar: 'المرحلة الإعدادية',
    //     fr: 'Collège',
    //     en: 'Middle Departement',
    //   },
    //   order: 1,
    //   image: 'college.jpg',
    //   attachments: [], // Attach Gir0 2025.png
    //   links: [], // TODO: fill it
    //   url: 'https://www.facebook.com/Ecole.Girard.Alexandria',
    //   type: 'admisison',
    //   isArchived: false,
    // },
    // {
    //   title: {
    //     ar: ' المرحلة الثانوية',
    //     fr: 'Lycée',
    //     en: 'Senior Departement',
    //   },
    //   order: 1,
    //   image: 'lycee.jpg',
    //   attachments: [], // Attach Gir0 2025.png
    //   links: [], // TODO: fill it
    //   url: 'https://www.facebook.com/Ecole.Girard.Alexandria',
    //   type: 'admisison',
    //   isArchived: false,
    // },
    // {
    //   title: {
    //     ar: 'الصف الأول من رياض الأطفال 2025-2026',
    //     fr: 'Moyenne Section 2025-2026',
    //     en: 'KG1 2025-2026',
    //   },
    //   order: 2,
    //   image: 'maternel 2025.png',
    //   attachments: [], // TODO : Attach maternel 2025.png
    //   links: [], // TODO: fill it
    //   url: 'https://forms.gle/3zfyZDSaLctFY6Mm6',
    //   type: 'admisison',
    //   isArchived: false,
    // },
    {
      title: {
        ar: 'تقديم وتحويلات 2026-2027',
        fr: 'Admission et transfert 2026-2027',
        en: 'Admission and transfer 2026-2027',
      },
      order: 1,
      image: 'Fleche.jpg',
      attachments: [], // Attach Gir0 2025.png
      links: [], // TODO: fill it
      url: 'https://docs.google.com/forms/d/e/1FAIpQLSdZZ87Ki8RNOrE1jlYPx5vB_LghHTDj4zrMk8IxBDr6ZjFhEg/closedform',
      type: 'admisison',
      isArchived: false,
    },
    // {
    //   title: {
    //     ar: 'التحويلات',
    //     fr: 'Transferts',
    //     en: 'Transfers',
    //   },
    //   order: 1,
    //   image: 'Fleche.jpg',
    //   attachments: [], // Attach Gir0 2025.png
    //   links: [], // TODO: fill it
    //   url: 'https://www.facebook.com/Ecole.Girard.Alexandria',
    //   type: 'admisison',
    //   isArchived: false,
    // },
  ],
};
